import api from './api';

// Serviço para gerenciar perfis
export const perfilService = {
  // Listar perfis com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/perfis', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar perfis');
    }
  },

  // Buscar perfil por ID
  async getById(id) {
    try {
      const response = await api.get(`/perfis/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar perfil');
    }
  },

  // Criar perfil
  async create(perfilData) {
    try {
      const response = await api.post('/perfis', perfilData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao criar perfil');
    }
  },

  // Atualizar perfil
  async update(id, perfilData) {
    try {
      const response = await api.put(`/perfis/${id}`, perfilData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar perfil');
    }
  },

  // Deletar perfil
  async delete(id) {
    try {
      const response = await api.delete(`/perfis/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir perfil');
    }
  },

  // Buscar permissões de um perfil
  async getPermissions(id) {
    try {
      const response = await api.get(`/perfis/${id}/permissoes`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar permissões do perfil');
    }
  },

  // Atualizar permissões de um perfil
  async updatePermissions(id, permissoes) {
    try {
      const response = await api.put(`/perfis/${id}/permissoes`, { permissoes });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar permissões do perfil');
    }
  },

  // Buscar estatísticas de perfis
  async getStats() {
    try {
      const response = await api.get('/perfis/stats');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar estatísticas');
    }
  },

  // Gerenciar permissões em lote
  async batchPermissions(perfilIds, permissaoIds, operacao) {
    try {
      const response = await api.post('/perfis/batch-permissions', {
        perfilIds,
        permissaoIds,
        operacao
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao processar permissões em lote');
    }
  },

  // Buscar permissões de múltiplos perfis
  async getMultiplePermissions(perfilIds) {
    try {
      const promises = perfilIds.map(id => this.getPermissions(id));
      const results = await Promise.all(promises);
      
      // Organizar resultado por perfil
      const permissoesPorPerfil = {};
      perfilIds.forEach((id, index) => {
        permissoesPorPerfil[id] = results[index].data || [];
      });
      
      return { data: permissoesPorPerfil };
    } catch (error) {
      throw new Error('Erro ao buscar permissões dos perfis');
    }
  }
};

export default perfilService;
